import PropTypes from 'prop-types';
import { Card, Text, Group, Stack, Badge, List, ThemeIcon, ScrollArea } from '@mantine/core';
import { IconSun, IconWindow, IconHome, IconPlant } from '@tabler/icons-react';
import { useSpreadsheetContext } from '../context/SpreadsheetContext';

const DesignPreviewCard = ({ 
	design, 
	isSelected, 
	onClick
}) => {
	const { plantData } = useSpreadsheetContext();
	
	const {
		zone,
		style,
		sunlight,
		windows,
		houseSize,
		bedConfig,
		chosenPlants,
		designName,
	} = design;

	const getPlantCommonName = (plantId) => {
		const plant = plantData.find(p => p.ID === plantId);
		return plant ? plant.Common : plantId;
	};

	console.log("chosenPlants = ", JSON.stringify(chosenPlants))
	return (
		<Card 
			shadow="sm" 
			padding="xs" 
			radius="md" 
			withBorder
			onClick={onClick}
			style={{ 
				cursor: 'pointer',
				backgroundColor: isSelected ? 'var(--mantine-color-blue-0)' : '#e8f5e9',
				transition: 'all 0.2s ease',
				width: '90%',
				minWidth: '550px',
				paddingBottom: '20px'
			}}
		>
			<Stack mt={0} mb={0} style={{ padding: '5px 20px' }}>
				<Text fw={500} size="lg" style={{ textAlign: 'left' }}>{`Design: ${designName}`}</Text>
				
				<Group gap="xs" wrap="nowrap">
					<Badge color="blue" variant="light" size="sm">{`Zone: ${zone}`}</Badge>
					<Badge color="green" variant="light" size="sm">{`Style: ${style}`}</Badge>
				</Group>

				<Group align="flex-start" gap="xl" direction="row">
					<Stack gap="xs">
						<Group gap="xs">
							<ThemeIcon size="sm" variant="light">
								<IconSun size={14} />
							</ThemeIcon>
							<Text size="sm">Sunlight: {sunlight}</Text>
						</Group>
						
						<Group gap="xs">
							<ThemeIcon size="sm" variant="light">
								<IconWindow size={14} />
							</ThemeIcon>
							<Text size="sm">Windows: {windows}</Text>
						</Group>

						<Group gap="xs">
							<ThemeIcon size="sm" variant="light">
								<IconHome size={14} />
							</ThemeIcon>
							<Text size="sm">House Size: {houseSize}</Text>
						</Group>
						
						<Text size="sm">Bed Config: {bedConfig}</Text>
					</Stack>

					{chosenPlants && chosenPlants.length > 0 && (
						<Stack gap="xs" style={{ flex: 1, alignItems: 'flex-start', paddingLeft: '50px' }}>
							<Group gap="xs" align="center" justify="flex-end">
								<ThemeIcon size="sm" variant="light">
									<IconPlant size={14} />
								</ThemeIcon>
								<Text size="sm" fw={500}>Selected Plants:</Text>
							</Group>
							<ScrollArea h="120" w="100%">
								<List size="sm" spacing="xs" style={{ textAlign: 'left', paddingLeft: '15px' }}>
									{chosenPlants.map((plant, index) => (
										<List.Item key={index}>
											<Text size="sm">
												{plant.category} - {getPlantCommonName(plant.plantId)} (Qty: {plant.quantity})
											</Text>
										</List.Item>
									))}
								</List>
							</ScrollArea>
						</Stack>
					)}
				</Group>
			</Stack>
		</Card>
	);
};

DesignPreviewCard.propTypes = {
	design: PropTypes.shape({
		zone: PropTypes.string.isRequired,
		style: PropTypes.string.isRequired,
		sunlight: PropTypes.string.isRequired,
		windows: PropTypes.string.isRequired,
		houseSize: PropTypes.number.isRequired,
		bedConfig: PropTypes.number.isRequired,
		chosenPlants: PropTypes.arrayOf(
			PropTypes.shape({
				category: PropTypes.string.isRequired,
				plantId: PropTypes.string.isRequired,
				quantity: PropTypes.number.isRequired
			})
		),
		designName: PropTypes.string.isRequired
	}).isRequired,
	isSelected: PropTypes.bool.isRequired,
	onClick: PropTypes.func.isRequired
};

export default DesignPreviewCard;
